(() => {
  const finePointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const setup = () => document.querySelectorAll('.header__inline-menu header-menu').forEach(menu => {
    if (menu.dataset.kupoHoverReady) return;
    menu.dataset.kupoHoverReady = 'true';
    const details = menu.querySelector('details');
    const summary = details?.querySelector('summary');
    if (!summary) return;
    let timer;
    const close = () => {
      clearTimeout(timer);
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    };
    menu.addEventListener('pointerenter', event => {
      if (!finePointer.matches || event.pointerType === 'touch') return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }, 120);
    });
    menu.addEventListener('pointerleave', () => {
      clearTimeout(timer);
      if (finePointer.matches) timer = setTimeout(() => {
        if (!menu.contains(document.activeElement)) close();
      }, 200);
    });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        close();
        summary.focus();
      }
    });
    finePointer.addEventListener('change', close);
  });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

